module.exports = __webpack_public_path__ + "02_very_short_grey.c354b2c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_very_short_grey.png
// module id = xVV8
// module chunks = 0